import { useCallback, useState } from "react";
const useBoolean = (defaultValue = false) => {
  const [visible, setVisible] = useState(defaultValue);

  const open = useCallback(() => {
    setVisible(true);
  }, []);
  const close = useCallback(() => {
    setVisible(false);
  }, []);

  return [visible, open, close];
};

export default useBoolean;
